export default __webpack_public_path__ + "static/media/image-homepage-profile@2x.39f9160a.jpg";